var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLimit = function SvgLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.777 12.568c0-2.043 0-3.064.635-3.699.635-.635 1.656-.635 3.699-.635h5.778c2.042 0 3.064 0 3.698.635.635.635.635 1.656.635 3.699s0 3.064-.635 3.698c-.634.635-1.656.635-3.698.635H7.11c-2.043 0-3.064 0-3.699-.635-.635-.634-.635-1.655-.635-3.698z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.668 9.036V7.59a4.333 4.333 0 1 1 8.667 0v1.445",
    stroke: "currentColor",
    strokeWidth: 1.481,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12.5,
    r: 1.25,
    fill: "currentColor"
  }))));
};
export default SvgLimit;